import React from 'react';
import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Icon from '../../assets/icons';

import * as S from './styles';
interface IProps {
  title: string;
  uniqueParamKey?: string;
  children: ReactNode;
  $bgColor?: string;
  $isDisabledPadding?: boolean;
}

const Accordion: FC<IProps> = ({
  children,
  title,
  uniqueParamKey,
  $bgColor,
  $isDisabledPadding,
}) => {
  const [params, setParams] = useSearchParams();
  const [isActive, setActive] = useState(false);

  const handleClick = useCallback(() => {
    if (isActive) {
      params.delete(`${uniqueParamKey ?? ''}_active_acc`);
    } else {
      params.set(`${uniqueParamKey ?? ''}_active_acc`, title);
    }

    setActive((prev) => !prev);
    setParams(params);
  }, [params, isActive]);

  useEffect(() => {
    const param = params.get(`${uniqueParamKey ?? ''}_active_acc`);

    if (!param) {
      return;
    }

    setActive(param === title);
  }, [params]);

  return (
    <S.Container
      $isActive={isActive}
      $bgColor={$bgColor}
      $isDisabledPadding={$isDisabledPadding}
    >
      <S.Title
        $isActive={isActive}
        onClick={handleClick}
      >
        {title} <Icon variant="arrow" />
      </S.Title>
      <S.Content $isActive={isActive}>{children}</S.Content>
    </S.Container>
  );
};

export default Accordion;
